export default {
  title: 'Audiencia de prueba',
  columns: {
    id: 'Id',
    phone_number: 'Número de teléfono',
  },
  filters: {
    search: {
      placeholder: 'Buscar',
    },
  },
  buttons: {
    send_test: 'Enviar prueba',
  },
  feedback: {
    success: 'Enviado con éxito',
    error: 'Error al enviar',
  },
};
